export default [
  {
    id: 1,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    document: '',
    status: 'APPROVED',
    remarks: 'aaaaa',
  },
  {
    id: 2,
    customerNum: "BS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 3,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 4,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 5,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 6,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 7,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 8,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 9,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 10,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 11,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
  {
    id: 12,
    customerNum: "HS-INDIA",
    showroomName: 'BLR',
    vendorShortKey: "NK",
    orderCategory: "RET",
    abNumber: '5909458 00',
    commissionName: "HS300101-NK-K1-SHEKARGOUDA-BLR",
    lpWg1: 8013.78,
    lpWg2: 282,
    totalLpWg1Wg2: 8295.78,
    stdDiscWg1: 88,
    spclDiscWg1: 0,
    stdDiscWg2: 88,
    spclDiscWg2: 0,
    rcblStdDiscWg1: 50,
    sdrWg1: 0,
    cumDiscWg1: 75,
    rcblStdDiscWg2: 10,
    sdrWg2: 0,
    cumDiscWg2: 10,
    discWG1Payable: 88,
    discWG2Payable: 10,
    splDiscWG1Payable: 0,
    splDiscWG2Payable: 0,
    pblStdDiscWg1: 75,
    sdpWg1: 20,
    pblCumDiscWg1: 80,
    pblStdDiscWg2: 10,
    sdpWg2: 0,
    pblCumDiscWg2: 10,
    nmeRcbl: 0,
    nmeRcblStd: 4260.69,
    nmeRcblAfterSdr: 2540.49,
    stdMargin: 685.94,
    marginAftSplDisc: 283.24,
    marginAftSplDiscPercent: 11.15,
    gestureToCustomer: 402.70,
    gesture: 13.68,
    nmePbl: 0,
    nmePblStd: 4260.69,
    nmePblAfterSdr: 2540.49,
    stdPblMargin: 685.94,
    pblMarginAftSplDisc: 283.24,
    pblMarginAftSplDiscPercent: 11.15,
    gestureToPbl: 402.70,
    gesturePbl: 13.68,
    documents: '',
    status: 'PENDING',
    remarks: ''
  },
];
